/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ActionContext, Module } from 'vuex';

import type RootStateType from '@/store/types';
import generateMutations, { UPDATE_STATE_TYPE } from '@/store/generate-mutations';
import { getGalileoAb } from '@/shared/galileoAb';
import { ABResEnum } from '@/enums/abExperiment';
import type { ApplyOptimizeStateType } from './types';

const moduleStore: Module<ApplyOptimizeStateType, RootStateType> = {
  state: {
    /** 提现页面优化实验结果 */
    applyOptimizeExperimentRes: null,
    /** 提现页面优化子实验结果 */
    applyOptimizeSubExperimentRes: null,
  },

  getters: {
    /**
     * 是否为简化版列表样式
     * 为提现页面优化实验的实验组或提现页面优化子实验的实验组
     */
    isSimplifiedListStyle(state: ApplyOptimizeStateType): boolean {
      return state.applyOptimizeExperimentRes === ABResEnum.HINT
      || state.applyOptimizeSubExperimentRes === ABResEnum.HINT;
    },
    /**
     * 是否为弹窗切换放款机构/渠道
     * 为提现页面优化实验组
     */
    isPopupSwitchChannel(state: ApplyOptimizeStateType): boolean | null {
      if (state.applyOptimizeExperimentRes === null) {
        return null;
      }
      return state.applyOptimizeExperimentRes === ABResEnum.HINT;
    },
  },
  actions: {
    /**
     * 伽利略实验：https://ab.hellobike.cn/experiment/detail/202507281055452441?isDetail=true
     * 实验名称：提现页面优化实验
     * 实验目的：测试提现页面优化实验分流结果
     */
    async getApplyOptimizeExperimentRes(
      context: ActionContext<ApplyOptimizeStateType, RootStateType>,
    ) {
      /**
       * 获取实验条件
       * 1. 未设置过实验结果
       */
      if (
        context.state.applyOptimizeExperimentRes === null
      ) {
        const { result } = await getGalileoAb().getAbResCatchError('202507281055452441', '202507281055452535');
        if (result) {
          context.dispatch(UPDATE_STATE_TYPE, {
            applyOptimizeExperimentRes: result,
          });
          // 对照组进入提现页面优化子实验
          if (result === ABResEnum.WAITHINT) {
            context.dispatch('getApplyOptimizeSubExperimentRes');
          }
        }
      }
    },
    /**
     * 伽利略实验：https://ab.hellobike.cn/experiment/detail/202511031109068356?isDetail=true
     * 实验名称：提现页面优化子实验
     * 实验目的：测试提现页面优化子实验分流结果
     */
    async getApplyOptimizeSubExperimentRes(
      context: ActionContext<ApplyOptimizeStateType, RootStateType>,
    ) {
      /**
       * 获取实验条件
       * 1. 未设置过实验结果
       */
      if (
        context.state.applyOptimizeSubExperimentRes === null
      ) {
        const { result } = await getGalileoAb().getAbResCatchError('202511031109068356', '202511031109068475');
        if (result) {
          context.dispatch(UPDATE_STATE_TYPE, {
            applyOptimizeSubExperimentRes: result,
          });
        }
      }
    },
  },
};

export default generateMutations(moduleStore);
